const callActiveMessage = 'To answer this call, please end the current call.';

export default callActiveMessage;
